module.exports = __webpack_public_path__ + "static/img/news_icon.347d6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news_icon.png
// module id = GQUm
// module chunks = 1